import React from 'react';
import { Drawer, Form, Input, Select, Button, Tooltip } from 'antd';
import { Minus, Plus } from 'lucide-react';
import { useClientForm } from './createClientDrawer.controller';

/** Small uppercase heading that groups related fields. */
const FormSection = ({ title, children }) => (
    <section>
        <h3 className="m-0 mb-3 text-xs font-semibold uppercase tracking-wide text-surface-500">{title}</h3>
        {children}
    </section>
);

export default function CreateClientDrawer({ users, open, setOpen, isEdit, client, setClient, createOrUpdateClient, disabled, contextHolder }) {
    const {
        gerenteUsers,
        asesorUsers,
        name,
        setName,
        rif,
        setRif,
        channel,
        setChannel,
        asesores,
        gerente,
        setGerente,
        gerenteValue,
        setAsesorAt,
        removeAsesorAt,
        addAsesor,
        onCloseDrawer
    } = useClientForm({ users, setOpen, isEdit, client, setClient });

    return (
        <Drawer
            title={
                <div>
                    <div className="text-base font-semibold text-surface-900">{isEdit ? 'Editar Cliente' : 'Crear Cliente'}</div>
                    <div className="text-xs font-normal text-surface-500">
                        {isEdit ? 'Modifica los datos del cliente' : 'Ingresa los datos del nuevo cliente'}
                    </div>
                </div>
            }
            onClose={onCloseDrawer}
            open={open}
            width={480}
            footer={
                <div className="flex justify-end gap-2">
                    <Button onClick={onCloseDrawer}>Cancelar</Button>
                    <Button
                        type="primary"
                        disabled={disabled}
                        onClick={async () => await createOrUpdateClient({ name, gerente, asesores, rif, channel, isEdit, gerenteUsers, onCloseDrawer })}>
                        {isEdit ? 'Guardar Cambios' : 'Crear Cliente'}
                    </Button>
                </div>
            }>
            {contextHolder}
            <Form layout="vertical" component="div" requiredMark className="space-y-6">
                <FormSection title="Información Básica">
                    <Form.Item label="Nombre del Cliente" required>
                        <Input placeholder="Ej: Supermercados XYZ" value={name} allowClear onChange={(e) => setName(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="RIF del Cliente" required>
                        <Input
                            placeholder="12345678-9"
                            value={rif}
                            allowClear
                            prefix={<span className="text-surface-400 font-medium">J-</span>}
                            onChange={(e) => setRif(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item label="Canal" required className="!mb-0">
                        <Select
                            value={channel}
                            options={[
                                { value: 'moderno', label: 'Canal Moderno' },
                                { value: 'tradicional', label: 'Canal Tradicional' }
                            ]}
                            onChange={(e) => setChannel(e)}
                        />
                    </Form.Item>
                </FormSection>

                <div className="border-t border-surface-100" />

                <FormSection title="Asignación de Equipo">
                    <Form.Item label="Gerente Responsable" required>
                        <Select
                            value={gerenteValue}
                            showSearch
                            optionFilterProp="label"
                            options={gerenteUsers?.map((user) => ({
                                label: user.name ?? '',
                                value: user._id?.toString() ?? ''
                            }))}
                            onChange={(e) => setGerente(e)}
                        />
                    </Form.Item>

                    <Form.Item label="Asesores Asignados" required className="!mb-0">
                        <div className="space-y-2">
                            {asesores.map((asesor, index) => {
                                const canRemove = asesores.length > 1 || Boolean(asesor);

                                return (
                                    <div key={index} className="flex items-center gap-2">
                                        <Select
                                            className="flex-1 min-w-0"
                                            value={asesor}
                                            showSearch
                                            optionFilterProp="label"
                                            options={asesorUsers?.map((user) => ({
                                                label: user.name ?? '',
                                                value: user._id ?? ''
                                            }))}
                                            onChange={(e) => setAsesorAt(index, e)}
                                        />
                                        {canRemove && (
                                            <Tooltip title="Quitar asesor">
                                                <Button danger icon={<Minus />} onClick={() => removeAsesorAt(index)} aria-label="Eliminar asesor" />
                                            </Tooltip>
                                        )}
                                        {index === asesores.length - 1 && (
                                            <Tooltip title="Agregar asesor">
                                                <Button icon={<Plus />} onClick={addAsesor} aria-label="Agregar asesor" />
                                            </Tooltip>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </Form.Item>
                </FormSection>
            </Form>
        </Drawer>
    );
}
